import React from 'react'
import TextEditor from './TextEditor'
import TTSControls from './TTSControls'

/**
 * 타임라인 아이템의 콘텐츠 섹션 (대본 + TTS)
 */
function ContentSection({
  section,
  editingSection,
  setEditingSection,
  isGeneratingTTS,
  onTextUpdate,
  onGenerateTTS,
  onAudioUpload
}) {
  return (
    <div className="timeline-content">
      <TextEditor
        section={section}
        editingSection={editingSection}
        setEditingSection={setEditingSection}
        onTextUpdate={onTextUpdate}
      />
      
      <TTSControls
        section={section}
        isGeneratingTTS={isGeneratingTTS}
        onGenerateTTS={onGenerateTTS}
        onAudioUpload={onAudioUpload}
      />
    </div>
  )
}

export default ContentSection